/**
 * WOW · feel preferences kept per device (own small persisted store, so the main app store stays
 * untouched): music / sound-effect volumes and haptics. Music on/off and SFX on/off stay in
 * Settings (store.settings.music / .sfx).
 */
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export interface FeelPrefs {
  /** 0..1 */
  musicVolume: number;
  /** 0..1 */
  sfxVolume: number;
  /** 0..1 — teacher / character voice clips (iOS ignores media element volume: hardware buttons only). */
  voiceVolume: number;
  haptics: boolean;
  set(p: Partial<Pick<FeelPrefs, 'musicVolume' | 'sfxVolume' | 'voiceVolume' | 'haptics'>>): void;
}

const safeStorage = createJSONStorage(() => ({
  getItem: (k: string) => {
    try {
      return localStorage.getItem(k);
    } catch {
      return null;
    }
  },
  setItem: (k: string, v: string) => {
    try {
      localStorage.setItem(k, v);
    } catch {
      /* private mode */
    }
  },
  removeItem: (k: string) => {
    try {
      localStorage.removeItem(k);
    } catch {
      /* ignore */
    }
  },
}));

export const useFeelPrefs = create<FeelPrefs>()(
  persist(
    (set) => ({
      musicVolume: 0.5,
      sfxVolume: 0.85,
      voiceVolume: 1,
      haptics: true,
      set: (p) => set(p),
    }),
    { name: 'sketchling-feel-v1', storage: safeStorage, partialize: (s) => ({ musicVolume: s.musicVolume, sfxVolume: s.sfxVolume, voiceVolume: s.voiceVolume, haptics: s.haptics }) },
  ),
);
